namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_fullscreen, {
		// Native popover defaults must not frame or pad the fullscreen app.
		border: { style: 'none' },
		padding: 0,
		background: { color: $mol_theme.back },
	})
}
